import ReactDOM from 'react-dom/client';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { chartColors } from './utils/design';
import { App } from './app';

// no-data 모듈 초기화
NoDataToDisplay(Highcharts);

// Set Highcharts default colors globally
Highcharts.setOptions({
  colors: chartColors,
  lang: { noData: '데이터가 없습니다' },
  noData: {
    style: { fontWeight: '500', fontSize: '13px', color: '#999' },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
